import { FunctionComponent, useCallback, useRef } from "react";
import { useHistory } from "react-router-dom";
import { FocusableComponentLayout, FocusContext, useFocusable } from "../../../../modules/spatialNavigation";
import { IDisplayedCast } from "../../../shared/artistCard/artist.interface";
import ArtistCard from "../../../shared/artistCard/ArtistCard";
import * as styles from "./styles.module.scss";
interface IProps {
  data: IDisplayedCast[];
}
const CastRowComponent: FunctionComponent<IProps> = (props) => {
  const scrollingRef = useRef<any>(null);
  const history = useHistory();
  const offsetLeftRef = useRef<any>(null);
  const { ref, focusKey, focused } = useFocusable({
    focusBoundaryDirections: ["left"],
    autoRestoreFocus: true,
    isFocusBoundary: true,
  });
  const onAssetFocus = useCallback(
    (l: FocusableComponentLayout, index: number) => {
      offsetLeftRef.current = l;
      scrollingRef.current.style.transform = `translateX(${index * (l.width + 8)}px)`;
      scrollingRef.current.style["-webkit-transform"] = `translateX(${index * (l.width + 8)}px)`;
    },
    [scrollingRef],
  );

  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref} className={styles.rowContainer}>
        <div className={styles.scrollingContainer + " " + styles.rowBox} ref={scrollingRef}>
          {props.data.map((item, index) => (
            <ArtistCard
              key={index}
              data={item}
              focusKey={`Artist${index}`}
              onEnterPress={() => {
                history.push(`/a/${item.artist.descriptor}`);
              }}
              onFocus={(l, e) => {
                onAssetFocus(l, index);
              }}
            />
          ))}
        </div>
      </div>
    </FocusContext.Provider>
  );
};
export default CastRowComponent;
